export const BASE_ROLES = {
  PSP_ADMIN: 'ROLE_PSP_ADMIN',
  PSP_USER: 'ROLE_PSP_USER',
  CUSTOMER_ADMIN: 'ROLE_CUSTOMER_ADMIN',
  CUSTOMER_LOCATION_ADMIN: 'ROLE_CUSTOMER_LOCATION_ADMIN',
  CUSTOMER_USER: 'ROLE_CUSTOMER_USER',
  CUSTOMER_WORK_COUNCIL: 'ROLE_WORK_COUNCIL',
  BUSINESS_USER: 'ROLE_BUSINESS_USER',
  MEDICAL_USER: 'ROLE_MEDICAL_USER',
} as const;
export type BaseRolesType = typeof BASE_ROLES[keyof typeof BASE_ROLES];
